import axios from 'axios'

import { SpotifyPlaylist } from 'src/Types'

const isMeetConditions = (playlist: SpotifyPlaylist): boolean => {
  const playlistRequirements = {
    min_followers_count: 1000,
    min_tracks_count: 20,
  }
  return (
    playlistRequirements.min_followers_count <= playlist.data.followers.total &&
    playlistRequirements.min_tracks_count <= playlist.data.tracks.total
  )
}

const isYourPlaylist = (
  playlist: SpotifyPlaylist,
  spotifyId: string
): boolean => playlist.data.owner.id === spotifyId

export const cutPlaylistId = (searchValue: string) => {
  const index = searchValue.indexOf('playlist')
  return searchValue
    .substring(index)
    .slice(9)
    .substring(0, 22)
}

type FindPlaylistArgsType = {
  accessToken: string
  spotifyId: string
  setError: (e: string) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setNewPlaylistToSet?: (p: any) => void
  setIsLoading: (load: boolean) => void
  searchValue: string
  allPlaylistsSpotifyIds?: string[]
}

export const findPlaylist = async ({
  accessToken,
  spotifyId,
  setError,
  setNewPlaylistToSet,
  setIsLoading,
  searchValue,
  allPlaylistsSpotifyIds,
}: FindPlaylistArgsType) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }

  try {
    setIsLoading?.(true)
    const playlistId = cutPlaylistId(searchValue)
    const apiURL = `https://api.spotify.com/v1/playlists/${playlistId}`
    const playlist = await axios.get(apiURL, config)
    const hasValidName =
      !!playlist.data.name.length && !playlist.data.name.match(/^[ ]+$/gm)
    const isPlaylistAlreadyAdded = allPlaylistsSpotifyIds?.includes(
      playlist.data?.id
    )
    if (
      hasValidName &&
      isYourPlaylist(playlist, spotifyId) &&
      isMeetConditions(playlist)
    ) {
      setError('')
      setNewPlaylistToSet?.(playlist.data)
      setIsLoading?.(false)
    }
    if (isPlaylistAlreadyAdded) {
      setError('validation.playlistAdded')
      setIsLoading?.(false)
      return
    }
    if (!isYourPlaylist(playlist, spotifyId)) {
      setError('validation.notYourPlaylist')
      setNewPlaylistToSet?.(null)
      setIsLoading?.(false)
      return
    }
    if (!hasValidName) {
      setError('playlistsPage.emptyPlaylistNameError')
      setNewPlaylistToSet?.(null)
      setIsLoading?.(false)
      return
    }
    if (!isMeetConditions(playlist)) {
      setError('validation.notRequirementsPlaylist')
      setNewPlaylistToSet?.(playlist.data)
      setIsLoading?.(false)
      return
    }

    setIsLoading?.(false)
  } catch (error) {
    setError('validation.incorrectLink')
    setNewPlaylistToSet?.(null)
    setIsLoading?.(false)
  }
}

type OnAddPlaylistArgsType = {
  onCheckPlaylist: (
    apiURL: string,
    callback: (
      error: string,
      response: { id: number | string; curator_id: number }
    ) => void
  ) => void
  setRecentlyAddedPlaylist: (url: string) => void
  toggle?: () => void
  searchValue: string
  eventHandler?: (response: { id: number | string; curator_id: number }) => void
}

export const onAddPlaylist = ({
  onCheckPlaylist,
  setRecentlyAddedPlaylist,
  toggle,
  searchValue,
  eventHandler,
}: OnAddPlaylistArgsType) => {
  const playlistId = cutPlaylistId(searchValue)
  const apiURL = `https://api.spotify.com/v1/playlists/${playlistId}`
  onCheckPlaylist(apiURL, (error, response) => {
    eventHandler && eventHandler(response)
    setRecentlyAddedPlaylist(apiURL)
    toggle?.()
  })
}
